import React from "react";
import cx from "./cx";
import RevButton from "./RevButton";

/** Números de página a pintar: primera, última y una ventana alrededor de la actual; null = «…» */
const pageWindow = (page, pages, radius) => {
    if (pages <= radius * 2 + 5) return Array.from({ length: pages }, (_, i) => i);
    const items = [0];
    const from = Math.max(1, Math.min(page - radius, pages - 2 - radius * 2));
    const to = Math.min(pages - 2, from + radius * 2);
    if (from > 1) items.push(null);
    for (let i = from; i <= to; i++) items.push(i);
    if (to < pages - 2) items.push(null);
    items.push(pages - 1);
    return items;
};

/**
 * Paginación de una lista en cliente (.rev-pagination): flechas + números de página.
 *  - page: página actual (base 0); pages: total de páginas; onChange(page)
 *  - prevLabel / nextLabel: aria-label de las flechas (los textos los pone la pantalla)
 *  - radius: páginas visibles a cada lado de la actual antes de acortar con «…» (2)
 * Con una sola página no pinta nada.
 */
const RevPagination = ({ page, pages, onChange, prevLabel, nextLabel, radius = 2, className, ...rest }) => {
    if (!pages || pages < 2) return null;
    return (
        <nav className={cx('rev-pagination', className)} role="navigation" aria-label="pagination" {...rest}>
            <RevButton variant="secondary" icon onClick={() => onChange(page - 1)} disabled={page === 0} aria-label={prevLabel}>
                <span className="material-icons rev-icon-sm">chevron_left</span>
            </RevButton>
            {pageWindow(page, pages, radius).map((i, idx) => (
                i === null
                    ? <span key={`gap-${idx}`} className="rev-pagination__gap" aria-hidden="true">…</span>
                    : <RevButton key={i} size="sm" variant={page === i ? 'primary' : 'secondary'}
                        aria-current={page === i ? 'page' : undefined} onClick={() => onChange(i)}>
                        {i + 1}
                    </RevButton>
            ))}
            <RevButton variant="secondary" icon onClick={() => onChange(page + 1)} disabled={page === pages - 1} aria-label={nextLabel}>
                <span className="material-icons rev-icon-sm">chevron_right</span>
            </RevButton>
        </nav>
    );
};

export default RevPagination;
